// extracted by mini-css-extract-plugin
export default {"Box":"ExportSponsorships-module__Box--s_JSh","Text":"ExportSponsorships-module__Text--fZJbB","Button":"ExportSponsorships-module__Button--hJXSA"};